import React from 'react';
import VoxelText, { TextVariant } from '../Text/VoxelText';

export interface VoxelSwitch {
  title?: string;
  offLabel?: string;
  onLabel?: string;
  disabled?: boolean;
  value?: boolean;
  onChange?: (checked: boolean) => void;
  color?: SwitchColor;
  size?: 'xs' | 'sm' | 'md';
}

export type SwitchColor = 'primary' | 'slate' | 'indigo' | 'emerald';

export const VoxelSwitch: React.FC<VoxelSwitch> = ({
  title,
  offLabel,
  onLabel,
  disabled,
  value = false,
  onChange,
  color = 'primary',
  size = 'md',
}) => {
  var flexGap: string = '';
  var titleFont: TextVariant = 'table';
  var labelFont: TextVariant = 'table';
  var componentSize: string = '';
  var relay: string = '';
  var buttonSize: string = '';
  var buttonTranslateOff: string = '';
  var buttonTranslateOn: string = '';

  if (size === 'xs') {
    titleFont = 'form-caption';
    flexGap = 'gap-1';
    labelFont = 'table';
    componentSize = 'w-[21px] h-[12px]';
    relay = '-top-[0px] h-[12px] w-[21px]';
    buttonSize = 'top-[0.5px] h-[11px] w-[11px]';
    buttonTranslateOff = 'translate-x-[0px]';
    buttonTranslateOn = 'translate-x-[9.5px]';
  }
  if (size === 'sm') {
    titleFont = 'form-caption';
    flexGap = 'gap-1.5';
    labelFont = 'table';
    componentSize = 'w-[26px] h-[16px]';
    relay = '-top-[0px] h-[16px] w-[26px]';
    buttonSize = 'top-[1px] h-[14px] w-[14px]';
    buttonTranslateOff = 'translate-x-[1px]';
    buttonTranslateOn = 'translate-x-[11px]';
  }
  if (size === 'md') {
    titleFont = 'bread-normal';
    flexGap = 'gap-2';
    labelFont = 'bread-medium';
    componentSize = 'w-9 h-[18px] ';
    relay = ' -top-[1px] h-[20px] w-[34px]';
    buttonSize = 'top-[0px] h-[18px] w-[18px]';
    buttonTranslateOff = 'translate-x-[1px]';
    buttonTranslateOn = 'translate-x-[15px]';
  }

  let relayColor = '';
  let buttonColor = '';
  let borderColor = '';

  // Unchecked states
  if (!value) {
    relayColor = 'bg-gray-100';
    buttonColor = 'bg-white';
    borderColor = 'border border-gray-300';
  }

  // Checked states
  if (color === 'primary') {
    if (value) {
      relayColor = 'bg-primary-600';
      buttonColor = 'bg-white';
    }
  }
  if (color === 'slate') {
    if (value) {
      relayColor = 'bg-slate-600';
      buttonColor = 'bg-white';
    }
  }
  if (color === 'emerald') {
    if (value) {
      relayColor = 'bg-emerald-600/80';
      buttonColor = 'bg-white';
    }
  }
  if (color === 'indigo') {
    if (value) {
      relayColor = 'bg-indigo-500';
      buttonColor = 'bg-white';
    }
  }

  return (
    <div
      className={`flex flex-row items-center gap-2 flex-nowrap ${flexGap} ${!disabled && 'cursor-pointer'
        } px-1`}
      onClick={() => !disabled && !!onChange && onChange(!value)}
    >
      {!!title?.length && (
        <VoxelText variant={titleFont} color={disabled ? 'hint' : 'medium'} noWrap>
          {title}
        </VoxelText>
      )}
      {!!offLabel?.length && (
        <VoxelText variant={labelFont} color={value || disabled ? 'hint' : 'light'} noWrap>
          {offLabel}
        </VoxelText>
      )}
      <div
        className={`relative ${!disabled && 'cursor-pointer'} inline-block 
        ${componentSize}
        `}
      >
        <input className={`opacity-0 w-0 h-0`} type="checkbox" role="switch" />
        {/* relay */}
        <div
          className={`
            absolute  ${relay}
            rounded-full transition-all
            ${relayColor} ${borderColor} 
        `}
        />
        {/* button */}
        <div
          className={`
            absolute top-0 bottom-0 content-[''] transition-all 
            rounded-full 
            ${buttonSize}
            ${!value ? buttonTranslateOff : ''}
            ${value ? buttonTranslateOn : ''}
            ${!disabled ? ' hover:drop-shadow-md' : ''} 
            ${buttonColor} ${borderColor}
        `}
        />
      </div>
      {!!onLabel?.length && (
        <VoxelText variant={labelFont} color={value ? 'dark' : 'hint'} noWrap>
          {onLabel}
        </VoxelText>
      )}
    </div>
  );
};

export default VoxelSwitch;
